class $28596a484afc798f$export$2e2bcd8739ae039 {
    info() {
        throw new Error("Method not implemented");
    }
    description() {
        throw new Error("No description given");
    }
    isApplicable(jsonData) {
        throw new Error("Method not implemented");
    }
    parseTransactions(jsonData) {
        throw new Error("Method not implemented");
    }
    toCsv(transactions) {
        const csvHeader = Object.keys(transactions[0]).join(";") + "\n";
        const csvRows = transactions.map((t)=>Object.values(t).join(";")).join("\n");
        const csvData = csvHeader + csvRows;
        return csvData;
    }
    toQif(transactions) {
        throw new Error("Method not implemented");
    }
}


class $b232144d1b483c8a$var$BarclaysPlugin extends (0, $28596a484afc798f$export$2e2bcd8739ae039) {
    info() {
        return "Barclays";
    }
    description() {
        return "Grab: AccountTransactionHistory";
    }
    isApplicable(jsonData) {
        try {
            // Method B
            const transactions = jsonData.Item?.Transactions;
            if (transactions && transactions.length > 0) return true;
            // Method A, InitialCallResponse
            for (const item of jsonData.Item?.InitialCallResponses){
                if (item.Response.Item.Transactions) return item.Response.Item.Transactions.length > 0;
            }
        } catch (error) {
            console.log("Barclays plugin inapplicable");
        }
        return false;
    }
    parseTransactions(jsonData) {
        var transactions = [];
        const itemTransactions = jsonData.Item?.Transactions;
        if (itemTransactions) {
            // proceed
            console.log("Detected Method B transactions");
            transactions = this.processTransactions(itemTransactions);
        } else jsonData.Item.InitialCallResponses.forEach((item)=>{
            const hasTransactions = item.Response.Item.Transactions;
            if (hasTransactions) {
                console.log("Method A transactions");
                //console.log(item.Response.Item.Transactions)
                transactions = this.processTransactions(item.Response.Item.Transactions);
            }
        });
        return transactions;
    }
    processTransactions(itemTransactions) {
        const transactions = [];
        itemTransactions.forEach((e)=>{
            let t = {};
            //console.log(e)
            t.TransactionDate = e.TransactionDate;
            t.ReferenceNumber = e.ReferenceNumber;
            t.Description = e.Description;
            t.Amount = e.Amount.Value;
            t.AmountCurrency = e.Amount.Currency.Code;
            t.LocalCurrencyAmount = e.LocalCurrencyAmount.Value;
            t.LocalCurrencyCurrency = e.LocalCurrencyAmount.Currency.Code;
            t.TransactionNature = e.TransactionNature;
            t.CountryCode = e.CountryCode;
            t.MerchantName = e.MerchantName;
            t.MobilePaymentType = e.MobilePaymentType ? e.MobilePaymentType : "";
            t.MerchantDataSearchCriteriaIdentifier = e.MerchantData.SearchCriteriaIdentifier;
            t.MerchantDataName = e.MerchantData.Name;
            //console.log(Object.values(t).join(';'))
            transactions.push(t);
        });
        return transactions;
    }
    toQif(transactions) {
        const qifHeader = [
            `!Account`,
            `NBarclays VISA`,
            `DMy Barclays transactions`,
            `TCCard`,
            `^`,
            `!Type:CCard`
        ];
        const qifTransactions = transactions.flatMap((t)=>[
                `D${this.formatDate(t.TransactionDate)}`,
                `T${t.TransactionNature == "Credit" ? t.LocalCurrencyAmount : -t.LocalCurrencyAmount}`,
                `M${t.MerchantName} ${t.MobilePaymentType}`,
                `P${t.Description}`,
                `^`
            ]);
        const qifContent = qifHeader.concat(qifTransactions).join("\n");
        return qifContent;
    }
    formatDate(text) {
        const date = new Date(text);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }
}
var $b232144d1b483c8a$export$2e2bcd8739ae039 = $b232144d1b483c8a$var$BarclaysPlugin;



class $eeeea1a43f18148d$var$KlarnaCard extends (0, $28596a484afc798f$export$2e2bcd8739ae039) {
    info() {
        return "Klarna Card";
    }
    description() {
        return "Grab: graphql (ActivityListV2)";
    }
    getItemRoot(jsonData) {
        return jsonData.data?.transactionsList?.items;
    }
    isApplicable(jsonData) {
        const itemroot = this.getItemRoot(jsonData);
        try {
            if (itemroot) {
                console.log("found the item root");
                return itemroot.length > 0;
            }
        } catch (error) {
            console.log("Klarna plugin inapplicable");
        }
        return false;
    }
    formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }
    parseTransactions(jsonData) {
        const items = this.getItemRoot(jsonData);
        const transactions = [];
        items.forEach((item)=>{
            //console.log(item)
            const result = {};
            result.title = item.title;
            result.uniqueId = item.uniqueId;
            result.createdAt = item.createdAt;
            result.createdAtDate = new Date(item.createdAt);
            result.date = this.formatDate(result.createdAtDate);
            result.rootCreatedAt = item.rootCreatedAt;
            result.rootCreatedAtDate = new Date(item.rootCreatedAt);
            result.isPending = item.isPending;
            //result.statusTitle = item.status?.title;
            //result.statusSubtitle = item.status?.subtitle ?? "";
            //result.fundingSources = item.status?.details?.userFundingSources?.map(fundingSrc => `${fundingSrc.altText} ${fundingSrc.maskedNumber}`) ?? "";
            //result.amount = item.amount.amount.replace('€', '').replace(',', '.').trim()
            result.amount = item.amount.currentAmount / 100.0;
            if (!item.amount.hasPlus) result.amount = -result.amount;
            result.amountCurrency = item.amount.currency;
            transactions.push(result);
        });
        return transactions;
    }
    toQif(transactions) {
        const qifHeader = [
            `!Account`,
            `NKlarna Card`,
            `DMy Klarna purchases`,
            `TCCard`,
            `^`,
            `!Type:CCard`
        ];
        const qifTransactions = transactions.flatMap((t)=>[
                `D${t.date}`,
                `T${t.amount}`,
                `M`,
                `P${t.title}`,
                `^`
            ]);
        const qifContent = qifHeader.concat(qifTransactions).join("\n");
        return qifContent;
    }
}
var $eeeea1a43f18148d$export$2e2bcd8739ae039 = $eeeea1a43f18148d$var$KlarnaCard;



class $b0cc5748036d0d10$var$KlarnaBank extends (0, $28596a484afc798f$export$2e2bcd8739ae039) {
    info() {
        return "Klarna Bank";
    }
    description() {
        return "Grab: /de/api/consumer_banking_bff/v1/graphql/transactions/ (2nd past tax-information)";
    }
    getEdges(jsonData) {
        let account = jsonData.data?.account?.transactionConnection?.edges;
        let currentAccount = jsonData.data?.currentAccount?.transactionConnection?.edges;
        if (account) return account;
        else if (currentAccount) return currentAccount;
        else return null;
    }
    isApplicable(jsonData) {
        try {
            let nodes = this.getEdges(jsonData);
            //let nodes = jsonData.data?.account?.transactionConnection?.edges
            if (nodes) return nodes.length > 0;
        } catch (error) {
            console.log("Klarna Bank inapplicable");
        }
        return false;
    }
    formatDate(dateText) {
        const date = new Date(dateText);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return `${month}/${day}/${year}`;
    }
    parseTransactions(jsonData) {
        const transactions = [];
        //let edges = jsonData.data?.account?.transactionConnection?.edges
        let edges = this.getEdges(jsonData);
        for (const e of edges){
            const t = {};
            const item = e.node;
            //console.log(e)
            //t.krn = item.krn;
            t.createdAt = item.createdAt;
            t.categoryKey = item.categoryKey;
            t.amountValue = item.amount.value;
            t.amountCurrency = item.amount.currency;
            t.referenceMessage = item.referenceMessage;
            t.otherPartyName = item.otherParty?.name;
            const otherParty = item.otherParty;
            switch(otherParty.__typename){
                case "SepaOtherParty":
                    t.otherParty = `${otherParty.name} ${otherParty.id}`;
                    break;
                case "CardTopUpOtherParty":
                    t.otherParty = `${otherParty.name} ${otherParty.brand} ${otherParty.cardNumber}`;
                    break;
                case "PoolAccount":
                    t.otherParty = `Pool: ${otherParty.name}`;
                    break;
                case "KlarnaOtherParty":
                    t.otherParty = `KlarnaOtherParty`;
                    break;
                default:
                    console.log(e);
                    throw new Error(`Unsupported: ${otherParty.__typename}`);
            }
            transactions.push(t);
        }
        return transactions;
    }
    toQif(transactions) {
        const qifHeader = [
            `!Account`,
            `NKlarna balance`,
            `DMy Klarna balance bank account`,
            `TBank`,
            `^`,
            `!Type:Bank`
        ];
        const qifTransactions = transactions.flatMap((t)=>{
            return [
                `D${this.formatDate(t.createdAt)}`,
                `T${t.amountValue / 100}`
            ].concat([
                t.referenceMessage,
                t.otherParty
            ].filter((e)=>e && e !== "") // filter empty lines
            .map((l)=>`M${l}`) // prefix with M
            .join("\n")).concat([
                `P${t.otherPartyName}`,
                `^`
            ]);
        });
        const qifContent = qifHeader.concat(qifTransactions).join("\n");
        return qifContent;
    }
}
var $b0cc5748036d0d10$export$2e2bcd8739ae039 = $b0cc5748036d0d10$var$KlarnaBank;



class $ad5a02ffbad3d364$var$ZiniaAmazon extends (0, $28596a484afc798f$export$2e2bcd8739ae039) {
    info() {
        return "Amazon VISA by Zinia";
    }
    description() {
        return "Grab: [...]/transactions[?lim...]";
    }
    isApplicable(jsonData) {
        try {
            return jsonData.elements.length > 0;
        } catch (error) {
            return false;
        }
    }
    parseTransactions(jsonData) {
        const transactions = [];
        for (const e of jsonData.elements){
            //jsonData.elements.forEach(e => {
            //console.log(e)    
            let t = {};
            t.id = e.id;
            t.date = e.date;
            t.merchantName = e.merchantDetails.name;
            t.merchantDetails = `${e.merchantDetails.name}, ${e.merchantDetails.address.city}, ${e.merchantDetails.address.countryCode}`;
            t.amountFirstTotal = e.amounts[0].totalAmount // TODO multi amounts
            ;
            t.amountFirstCurrency = e.amounts[0].currency;
            // Skip reward redemptions
            if (e.reward?.signedAmount < 0) console.log(`disregarding empty transaction`);
            else {
                t.cashback = e.reward?.signedAmount ? `${e.reward.amount} points earned` : "";
                console.log(t);
                console.log(Object.values(t).join(";"));
                transactions.push(t);
            }
        }
        return transactions;
    }
    toQif(transactions) {
        const qifHeader = [
            `!Account`,
            `NAmazon VISA`,
            `DMy Amazon VISA by Zinia transactions`,
            `TCCard`,
            `^`,
            `!Type:CCard`
        ];
        const qifTransactions = transactions.flatMap((t)=>[
                `D${t.date}`,
                `T${t.amountFirstTotal}`,
                `M${t.merchantDetails}`,
                `P${t.merchantName}`,
                `^`
            ]);
        const qifContent = qifHeader.concat(qifTransactions).join("\n");
        return qifContent;
    }
}
var $ad5a02ffbad3d364$export$2e2bcd8739ae039 = $ad5a02ffbad3d364$var$ZiniaAmazon;


function $ff9f5a0c49746e40$export$c7db45073be5a171(content) {
    return new Blob([
        content
    ], {
        type: "text/csv;charset=utf-8;"
    });
}



class $7e0e62f91509f50e$var$ConsorsDepot extends (0, $28596a484afc798f$export$2e2bcd8739ae039) {
    COMMISSION_RATES = {
        "ISHSV-MSCI ACWI DL A": 0.015,
        "UBISOFT ENTMT IN.EO-,0775": 0.018,
        "ISHS-MS.ACW.SRI DLD": 0.1,
        "AM-PRIME GL.E. DLA": 0.0,
        "VANG.FTSE A.-WO.U.ETF DLD": 0.015
    };
    info() {
        return "Consors Depot";
    }
    description() {
        return "Grab: .../orders[?excl...]";
    }
    isApplicable(jsonData) {
        try {
            let orders = jsonData.order;
            if (orders) return orders.length > 0;
        } catch (error) {
            console.log("Consors Depot inapplicable");
        }
        return false;
    }
    formatDate(dateText) {
        const date = new Date(dateText);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return `${month}/${day}/${year}`;
    }
    parseTransactions(jsonData) {
        const transactions = [];
        let orders = jsonData.order;
        for (const baseOrder of orders)baseOrder.execution.forEach((execution)=>{
            const t = {};
            t.orderno = execution.orderno;
            t.quotation = execution.quotation;
            t.quotationCurrency = execution.quotationCurrency;
            t.quotationDateTime = execution.quotationDateTime;
            t.securityAmountExecuted = execution.securityAmountExecuted;
            t.valueDate = execution.valueDate;
            t.securityIsin = baseOrder.securityIsin;
            t.securityName = baseOrder.securityName;
            t.securityWkn = baseOrder.securityWkn;
            t.clearingAccountno = baseOrder.clearingAccountno;
            t.ordertype = baseOrder.ordertype;
            transactions.push(t);
        });
        return transactions;
    }
    toQif(transactions) {
        const qifTransactions = transactions.flatMap((t)=>{
            console.log(t.securityAmountExecuted * t.quotation);
            t.commissionRate = this.getCommissionRate(t);
            t.ordertotal = t.securityAmountExecuted * t.quotation;
            t.commission = t.ordertotal * t.commissionRate;
            t.total = t.ordertotal + t.commission;
            return [
                `D${this.formatDate(t.quotationDateTime)}`,
                `N${this.convertOrderType(t.ordertype)}`,
                `Y${t.securityName}`,
                `I${t.quotation}`,
                `Q${t.securityAmountExecuted}`,
                `MOrder ${t.orderno}`,
                `O${t.commission}`,
                `T${t.total}`,
                `L[consors Verrechnungskonto]`,
                `^`
            ];
        });
        const qifHeader = [
            `!Account`,
            `Nconsors Verrechnungskonto:consors Depot`,
            `DMy Consors Depot`,
            `TInvst`,
            `^`,
            `!Type:Invst`
        ];
        const qifContent = qifHeader.concat(qifTransactions).join("\n");
        return qifContent;
    }
    roundToTwo(num) {
        return +(Math.round(num + "e+2") + "e-2");
    }
    convertOrderType(ordertype) {
        switch(ordertype){
            case "B":
                return "Buy";
            default:
                throw new Error("Unsupported ordertype: " + ordertype);
        }
    }
    getCommissionRate(transaction) {
        let rate = 0.0;
        if (transaction.securityName in this.COMMISSION_RATES) rate = this.COMMISSION_RATES[transaction.securityName];
        else throw Error("Unknown commission rate for: " + transaction.securityName);
        return rate;
    }
    formatDate(dateText) {
        const date = new Date(dateText);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return `${month}/${day}/${year}`;
    }
}
var $7e0e62f91509f50e$export$2e2bcd8739ae039 = $7e0e62f91509f50e$var$ConsorsDepot;



class $9e6fe04d9319e276$var$Revolut extends (0, $28596a484afc798f$export$2e2bcd8739ae039) {
    info() {
        return "Revolut";
    }
    description() {
        return "Grab: last?[...]";
    }
    isApplicable(jsonData) {
        if (jsonData && jsonData.length > 0) {
            const invalidentries = jsonData.some((e)=>{
                return !e.type || !e.state || !e.category;
            });
            return !invalidentries;
        }
        return false;
    }
    parseTransactions(jsonData) {
        return jsonData.map((e)=>{
            let t = {};
            t.id = e.id;
            t.type = e.type;
            t.state = e.state;
            t.createdDate = e.createdDate;
            t.currency = e.currency;
            t.amount = e.amount / 100;
            t.fee = e.fee;
            t.description = e.description;
            t.category = e.category;
            t.comment = e.comment ? e.comment : "";
            return t;
        });
    }
    toQif(transactions) {
        const qifHeader = [
            `!Account`,
            `NRevolut`,
            `DMy Revolut transactions`,
            `TBank`,
            `^`,
            `!Type:Bank`
        ];
        const qifTransactions = transactions.flatMap((t)=>[
                `D${this.formatDate(t.createdDate)}`,
                `T${t.amount}`,
                `M${t.type}`,
                `P${t.description}`,
                `^`
            ]);
        const qifContent = qifHeader.concat(qifTransactions).join("\n");
        return qifContent;
    }
    formatDate(unixtimems) {
        const date = new Date(unixtimems);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }
}
var $9e6fe04d9319e276$export$2e2bcd8739ae039 = $9e6fe04d9319e276$var$Revolut;


const $7d4be14eaf8844c4$var$plugins = [
    new (0, $9e6fe04d9319e276$export$2e2bcd8739ae039)(),
    new (0, $eeeea1a43f18148d$export$2e2bcd8739ae039)(),
    new (0, $b0cc5748036d0d10$export$2e2bcd8739ae039)(),
    new (0, $b232144d1b483c8a$export$2e2bcd8739ae039)(),
    new (0, $ad5a02ffbad3d364$export$2e2bcd8739ae039)(),
    new (0, $7e0e62f91509f50e$export$2e2bcd8739ae039)()
];
// TODO maybe turn into initial available plugins:
const $7d4be14eaf8844c4$var$pluginsDiv = document.getElementById("pluginsDiv");
$7d4be14eaf8844c4$var$plugins.forEach((plugin)=>{
    console.log(plugin.info());
});
$7d4be14eaf8844c4$var$pluginsDiv.insertAdjacentHTML("beforeend", $7d4be14eaf8844c4$var$plugins.map((p)=>`${p.info()}: ${p.description()}`).join("<br>"));
function $7d4be14eaf8844c4$var$appendResultText(text) {
    const textOut = document.getElementById("outputTxt");
    textOut.innerText += "\n";
    textOut.innerText += text;
}
const $7d4be14eaf8844c4$var$textIn = document.getElementById("inputTxt");
const $7d4be14eaf8844c4$var$textOut = document.getElementById("outputTxt");
const $7d4be14eaf8844c4$var$pluginChoice = document.getElementById("pluginChoice");
var $7d4be14eaf8844c4$var$chosenPlugin = null;
var $7d4be14eaf8844c4$var$transactions = [];
var $7d4be14eaf8844c4$var$qifContent = "";
var $7d4be14eaf8844c4$var$csvContent = "";
$7d4be14eaf8844c4$var$textIn.addEventListener("input", function(event) {
    console.log("input event triggered");
    const inputValue = event.target.value;
    $7d4be14eaf8844c4$var$qifContent = "";
    $7d4be14eaf8844c4$var$csvContent = "";
    try {
        const jsonData = JSON.parse(inputValue);
        console.log("attaining plugins");
        $7d4be14eaf8844c4$var$plugins.forEach((plugin)=>console.log(plugin.info()));
        const applicablePlugins = $7d4be14eaf8844c4$var$plugins.filter((plugin)=>plugin.isApplicable(jsonData));
        console.log(applicablePlugins);
        // Only wanna continue with one from here, TODO create plugin-SELECT
        if (applicablePlugins.length < 1) throw new Error("No plugin able to parse given json");
        $7d4be14eaf8844c4$var$chosenPlugin = applicablePlugins[0];
        console.log(`Selected plugin ${$7d4be14eaf8844c4$var$chosenPlugin.info()}`);
        $7d4be14eaf8844c4$var$pluginChoice.innerText = `Selected plugin: ${$7d4be14eaf8844c4$var$chosenPlugin.info()}`;
        $7d4be14eaf8844c4$var$transactions = $7d4be14eaf8844c4$var$chosenPlugin.parseTransactions(jsonData);
        //let transactions = parseTransactions(inputValue);
        $7d4be14eaf8844c4$var$qifContent = $7d4be14eaf8844c4$var$chosenPlugin.toQif($7d4be14eaf8844c4$var$transactions);
        $7d4be14eaf8844c4$var$csvContent = $7d4be14eaf8844c4$var$chosenPlugin.toCsv($7d4be14eaf8844c4$var$transactions);
        $7d4be14eaf8844c4$var$textOut.innerText = $7d4be14eaf8844c4$var$qifContent;
    } catch (error) {
        console.error("An error occurred:", error.message);
        $7d4be14eaf8844c4$var$textOut.innerText = error.message;
    }
});
function $7d4be14eaf8844c4$var$createDownloadButton(elementId, fnContent, fnFileName) {
    const targetBtn = document.getElementById(elementId);
    targetBtn.addEventListener("click", async function() {
        if (!$7d4be14eaf8844c4$var$chosenPlugin || !fnContent()) {
            alert("Content unavailable");
            return;
        }
        const blob = (0, $ff9f5a0c49746e40$export$c7db45073be5a171)(fnContent());
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${fnFileName()}`.toLowerCase().replace(" ", "_");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}
$7d4be14eaf8844c4$var$createDownloadButton("downloadQif", ()=>$7d4be14eaf8844c4$var$qifContent, ()=>"transactions.qif");
$7d4be14eaf8844c4$var$createDownloadButton("downloadCsv", ()=>$7d4be14eaf8844c4$var$csvContent, ()=>"transactions.csv");
$7d4be14eaf8844c4$var$textIn.disabled = false;
$7d4be14eaf8844c4$var$textIn.placeholder = "Paste input JSON here";
// Fire initial event
const $7d4be14eaf8844c4$var$event = new Event("input", {
    bubbles: true,
    cancelable: true
});
$7d4be14eaf8844c4$var$textIn.dispatchEvent($7d4be14eaf8844c4$var$event);


//# sourceMappingURL=index.120df123.js.map
